
<div class="bsk-container">
    <img class="logo" src="assets/images/logo.png">
    <button (click)="loginWithMicrosoft()" class="bsk-btn bsk-btn-default">
      <object type="image/svg+xml" data="https://s3-eu-west-1.amazonaws.com/cdn-testing.web.bas.ac.uk/scratch/bas-style-kit/ms-pictogram/ms-pictogram.svg" class="x-icon"></object> 
      Sign in with Microsoft</button>
  </div>